import React from 'react'
//import {Route} from 'react-router-dom'
import {push} from 'react-router-redux'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

//import config from '../../config.js'

import {setRedirectUrl} from 'Skelet/src/modules/fetch.action.js'
import Header from './CoreRouteHeader.js'
import i18n_texts from '../../i18n.js';


class CoreRoute extends React.Component {

  componentDidMount() {
    if (!this.props.session_token) {
      this.props.setRedirectUrl(this.props.currentURL);
      this.props.redirectToLogin();
    }
  }

  render() {
    if(this.props.session_token) {
      return (
        <div>
          <Header i18n_texts={i18n_texts} app_language={this.props.lang} />
          <main>
            {/*<Route {...this.props} abc="def" />
            this doesn't pass the props, except for the [this.props], which are passed down from app.js
            cloneElement crashes because of an undefined error, even though it does work with CREATEelement.. */}
            {React.createElement(this.props.component, {
              app_language: this.props.lang,
              i18n_texts
            })}
          </main>
        </div>
      );
    } else {
      return null
    }
  }

}


function mapStateToProps(state, ownProps) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && state.apiData["login"]["data"]["token"] !== undefined) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    currentURL: ownProps.location.pathname
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    redirectToLogin: () => push('/start'),
    setRedirectUrl,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CoreRoute)



// WEBPACK FOOTER //
// ./src/containers/route-containers/CoreRoute.js